import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IDetailProps } from '../../models/forms/IForm';
import { IKishuVM } from '../../models/response/IKishuResponse';

const KishuMarkDetails = (props: IDetailProps) => {
  const { kishuMarkStore } = useStore();
  const { GetKishuByIdService, kishuDetails } = kishuMarkStore;

  const kishuDetail: IKishuVM = kishuDetails;

  useEffect(() => {
    if (props.selectedRowId > 0) {
      GetKishuByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.selectedRowId
      );
    }
  }, [props.selectedRowId]);

  return (
    <>
      <div className="px-4 py-3">
        <div className="row g-2">
          <div className="col-auto pt-1 text-muted">
<svg
   version="1.1"
   id="svg9"
   width="30"
   height="30"
   fill="currentColor"
   stroke='currentColor'
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"><defs
     id="defs13"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath23"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path21" /></clipPath></defs><g
     id="g15"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g17"><g
         id="g19"
         clipPath="url(#clipPath23)"><g
           id="g25"
           transform="translate(317.3101,70.2002)"><path className='kisuICON'
             d="m 0,0 c 27.93,-32.41 57.75,-59.29 57.75,-59.29 0,0 105.48,95.06 105.48,143.15 0,32.31 -26.19,58.5 -58.5,58.5 -19.24,0 -36.31,-9.29 -46.97,-23.62 -10.66,14.33 -27.73,23.62 -46.97,23.62 -32.31,0 -58.5,-26.19 -58.5,-58.5 0,-19.52 17.39,-46.8 38.04,-72.31"
       id="path27" /></g><g
           id="g29"
           transform="translate(338.4116,261.2598)"><path className='kisuICON'
             d="M 0,0 H 73.315"
           id="path31" /></g><g
           id="g33"
           transform="translate(375.0693,336.3369)"><path className='kisuICON'
             d="M 0,0 V -75.077"
          id="path35" /></g><g
           id="g37"
           transform="translate(430.249,414.7148)"><path className='kisuICON'
             d="m 0,0 c -1.659,0 -3.296,-0.086 -4.92,-0.22 5.595,9.03 8.834,19.673 8.834,31.077 0,32.636 -26.457,59.093 -59.094,59.093 -32.636,0 -59.093,-26.457 -59.093,-59.093 0,-11.404 3.238,-22.047 8.834,-31.077 -1.624,0.134 -3.262,0.22 -4.92,0.22 -32.637,0 -59.094,-26.457 -59.094,-59.094 0,-32.636 26.457,-59.093 59.094,-59.093 25.18,0 46.67,15.757 55.179,37.944 8.51,-22.187 29.999,-37.944 55.18,-37.944 32.636,0 59.093,26.457 59.093,59.093 C 59.093,-26.457 32.636,0 0,0 Z"
        id="path39" /></g><g
           id="g41"
           transform="translate(202.8223,110.7446)"><path className='kisuICON'
             d="M 0,0 -77.865,-98.83 -155.73,0 -77.865,98.83 Z"
          id="path43" /></g><g
           id="g45"
           transform="translate(88.2998,261.2598)"><path className='kisuICON'
             d="M 0,0 H 73.315"
          id="path47" /></g><g
           id="g49"
           transform="translate(124.9575,340.7803)"><path className='kisuICON'
             d="M 0,0 V -79.521"
         id="path51" /></g><g
           id="g53"
           transform="translate(66.043,303.8159)"><path className='kisuICON'
             d="M 0,0 C 0,0 36.821,-5.717 58.915,35.523 81.007,-5.717 117.829,0 117.829,0 c 0,0 46.641,8.521 43.204,66.29 -3.383,56.858 -102.118,132.337 -102.118,132.337 0,0 -98.737,-75.479 -102.119,-132.337 C -46.641,8.521 0,0 0,0 Z"
           id="path55" /></g><g
           id="g57"
           transform="translate(428.0693,131.7383)"><path className='kisuICON'
             d="M 0,0 H -106"
         id="path59" /></g></g></g></g></svg>

          </div>
          <div className="col-10">
            <p className="title_sidebar">
              <FormattedMessage id={'kishu'} />{' '}
            </p>
            <h3 className="mb-0">{kishuDetail.Kishu}</h3>
          </div>
        </div>

        <div className="row g-2 mt-4">
          <div className="col-auto pt-1 text-muted">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" fill="currentColor"
              viewBox="0 0 512 512">
              <g>
                <g>
                  <path d="M480.6,228.731c-20.726-37.899-52.833-68.109-83.883-97.324c-5.46-5.138-10.619-9.991-15.748-14.916
			c-19.241-18.475-38.722-36.288-57.562-53.512c-18.702-17.099-38.04-34.78-57.011-52.996L256.001,0l-10.395,9.981
			c-18.971,18.216-38.31,35.897-57.011,52.996c-18.84,17.226-38.321,35.037-57.562,53.512c-5.129,4.925-10.285,9.777-15.746,14.914
			C84.235,160.62,52.127,190.831,31.4,228.731C4.544,277.84,5.288,332.38,33.445,378.37c34.926,57.043,83.617,69.326,118.313,69.585
			c18.044,0.142,36.075-3.004,53.261-9.192c-3.776,15.589-8.613,24.071-12.691,26.941l-6.372,4.484V512h140.087h0v-41.812
			l-6.372-4.484c-4.078-2.869-8.916-11.351-12.691-26.94c17.186,6.188,35.232,9.334,53.26,9.192
			c34.697-0.259,83.388-12.542,118.313-69.586C506.711,332.38,507.457,277.839,480.6,228.731z M452.955,362.695
			c-22.263,36.362-53.531,54.948-92.936,55.242c-22.387,0.123-44.799-5.963-64.829-17.727l-25.602-15.037l3.072,29.532
			c3.306,31.782,10.21,53.964,20.998,67.276h-75.314c10.788-13.311,17.692-35.494,20.998-67.274l3.072-29.532l-25.603,15.037
			c-20.029,11.763-42.453,17.894-64.829,17.727c-39.404-0.294-70.673-18.881-92.936-55.242
			c-22.388-36.568-22.865-80.146-1.309-119.561c18.436-33.713,48.777-62.261,78.119-89.869c5.273-4.962,10.728-10.093,15.966-15.123
			c18.976-18.221,38.32-35.907,57.026-53.011c15.448-14.124,31.326-28.642,47.151-43.597c15.825,14.955,31.703,29.473,47.151,43.597
			c18.707,17.104,38.051,34.79,57.026,53.011c5.24,5.031,10.694,10.162,15.969,15.125c29.34,27.607,59.681,56.154,78.117,89.866
			C475.82,282.549,475.343,326.128,452.955,362.695z"/>
                </g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
            </svg>
          </div>
          <div className="col-10">
            <p className="title_sidebar">
              <FormattedMessage id={'kishu_mark'} />{' '}
            </p>
            <h3 className="mb-0">
              {
                // kishuMarkOptions.filter(
                //   (k) => k.id === Number(kishuDetail.KishuMark)
                // )[0].value
                kishuDetail.KishuMark
              }
            </h3>
          </div>
        </div>

        <div className="row g-2 mt-4">
          <div className="col-auto pt-1 text-muted">
            <svg
              version="1.1"
              id="fi_134808"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              x="0px"
              fill="currentColor"
              y="0px"
              viewBox="0 0 60 60"
            >
              <g>
                <path d="M10,25.465h13c0.553,0,1-0.448,1-1s-0.447-1-1-1H10c-0.553,0-1,0.448-1,1S9.447,25.465,10,25.465z"></path>
                <path d="M36,29.465H10c-0.553,0-1,0.448-1,1s0.447,1,1,1h26c0.553,0,1-0.448,1-1S36.553,29.465,36,29.465z"></path>
                <path d="M36,35.465H10c-0.553,0-1,0.448-1,1s0.447,1,1,1h26c0.553,0,1-0.448,1-1S36.553,35.465,36,35.465z"></path>
                <path
                  d="M54.072,2.535L19.93,2.465c-3.27,0-5.93,2.66-5.93,5.93v5.124l-8.07,0.017c-3.27,0-5.93,2.66-5.93,5.93v21.141
		c0,3.27,2.66,5.929,5.93,5.929H12v10c0,0.413,0.254,0.784,0.64,0.933c0.117,0.045,0.239,0.067,0.36,0.067
		c0.276,0,0.547-0.115,0.74-0.327l9.704-10.675l16.626-0.068c3.27,0,5.93-2.66,5.93-5.929v-0.113l5.26,5.786
		c0.193,0.212,0.464,0.327,0.74,0.327c0.121,0,0.243-0.022,0.36-0.067c0.386-0.149,0.64-0.52,0.64-0.933v-10h1.07
		c3.27,0,5.93-2.66,5.93-5.929V8.465C60,5.196,57.341,2.536,54.072,2.535z M44,40.536c0,2.167-1.763,3.929-3.934,3.929l-17.07,0.07
		c-0.28,0.001-0.548,0.12-0.736,0.327L14,53.949v-8.414c0-0.552-0.447-1-1-1H5.93c-2.167,0-3.93-1.763-3.93-3.929V19.465
		c0-2.167,1.763-3.93,3.932-3.93l9.068-0.019c0,0,0,0,0,0c0.001,0,0.001,0,0.002,0l25.068-0.052c2.167,0,3.93,1.763,3.93,3.93
		v18.441V40.536z M58,29.606c0,2.167-1.763,3.929-3.93,3.929H52c-0.553,0-1,0.448-1,1v8.414l-5-5.5V19.395
		c0-3.27-2.66-5.93-5.932-5.93L16,13.514v-5.12c0-2.167,1.763-3.93,3.928-3.93l34.141,0.07c0.001,0,0.001,0,0.002,0
		c2.167,0,3.93,1.763,3.93,3.93V29.606z"
                ></path>
              </g>
            </svg>
          </div>
          <div className="col-10">
            <p className="title_sidebar">
              <FormattedMessage id={'remarks'} />{' '}
            </p>
            <h3 className="mb-0">{kishuDetail.Remarks || '--'}</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(KishuMarkDetails);
